var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating"},_vm._l(([1, 2, 3, 4, 5]),function(start,index){return _c('i',{key:index,staticClass:"material-icons",class:{ active: index < _vm.rating }},[_vm._v("star")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }